import type { Category } from '../../components/agent/scheduleDay'

/**
 * docs/product/scheduling-model.md's "Schedule defaults": for each weekday,
 * what a person normally works, and which weekdays are regular days off. An
 * agent's real week is read from the tables a supervisor writes it to
 * (scheduleDefaultStore.ts, shown on AgentScheduleTemplatePage.tsx).
 * SHIFT_TEMPLATE is only the shift time the board codes label a work day with
 * (boardCodes.ts), the field office's own Day Shift.
 */
export const SHIFT_TEMPLATE = {
  name: 'Day Shift',
  time: '0700–1500',
  appliesTo: 'Monday–Friday',
}

export type WeekdayDefault = {
  weekday: string
  category: Category
  assignment?: string
}
